export default {
  // 通用
  common: {
    confirm: '確認',
    cancel: '取消',
    save: '保存',
    delete: '刪除',
    edit: '編輯',
    add: '添加',
    search: '搜索',
    reset: '重置',
    submit: '提交',
    back: '返回',
    close: '關閉',
    loading: '加載中...',
    noData: '暫無數據',
    operation: '操作',
    status: '狀態',
    sort: '排序',
    createTime: '創建時間',
    updateTime: '更新時間',
    actions: '操作',
    enable: '啟用',
    disable: '禁用',
    active: '活躍',
    inactive: '未激活'
  },
  
  // 导航菜单
  nav: {
    dashboard: '儀表盤',
    products: '產品管理',
    productList: '產品列表',
    categories: '分類管理',
    company: '公司信息',
    cases: '客戶案例',
    caseStudies: '案例研究',
    faq: '常見問題',
    advantages: '核心優勢',
    process: '服務流程',
    inquiries: '咨詢管理',
    siteConfig: '網站配置',
    translations: '翻譯管理'
  },
  
  // 登录
  login: {
    title: 'CMS 管理系統',
    username: '用戶名',
    password: '密碼',
    loginBtn: '登錄',
    logout: '退出登錄',
    usernamePlaceholder: '請輸入用戶名',
    passwordPlaceholder: '請輸入密碼',
    rememberMe: '記住我',
    forgotPassword: '忘記密碼？',
    tips: '提示',
    success: '登錄成功',
    error: '登錄失敗，請檢查用戶名和密碼'
  },
  
  // 仪表盘
  dashboard: {
    title: '歡迎使用 CMS 管理系統',
    subtitle: '企業官網內容管理系統',
    totalProducts: '產品總數',
    totalCases: '案例總數',
    totalInquiries: '咨詢總數',
    systemStatus: '系統狀態',
    quickAccess: '快捷入口',
    recentActivity: '最近活動'
  },
  
  // 产品管理
  product: {
    listTitle: '產品列表',
    createTitle: '新增產品',
    editTitle: '編輯產品',
    productId: '產品 ID',
    name: '產品名稱',
    shortName: '簡稱',
    category: '所屬分類',
    description: '產品描述',
    price: '價格',
    priceUnit: '價格單位',
    imageUrl: '主圖',
    badge: '標籤',
    demoUrl: '演示地址',
    features: '功能特性',
    highlights: '產品亮點',
    techStack: '技術棧',
    screenshots: '截圖展示',
    status: '狀態',
    allCategories: '全部分類',
    addFeature: '添加功能',
    addHighlight: '添加亮點',
    addTech: '添加技術',
    addScreenshot: '添加截圖',
    uploadImage: '上傳圖片',
    selectCategory: '選擇分類'
  },
  
  // 分类管理
  category: {
    categoryId: '分類 ID',
    name: '分類名稱',
    icon: '圖標',
    sortOrder: '排序',
    status: '狀態'
  },
  
  // 公司信息
  company: {
    name: '公司名稱',
    englishName: '英文名稱',
    slogan: '口號',
    description: '公司簡介',
    founded: '成立時間',
    employees: '員工人數',
    clients: '客戶數量',
    projects: '項目數量',
    phone: '聯系電話',
    email: '聯系郵箱',
    address: '公司地址',
    workHours: '工作時間',
    wechatLink: '微信鏈接',
    weiboLink: '微博鏈接',
    linkedinLink: '領英鏈接'
  },
  
  // 客户案例
  clientCase: {
    name: '客戶名稱',
    industry: '所屬行業',
    systemType: '系統類型',
    logoIcon: 'Logo 圖標',
    description: '案例描述',
    results: '成果展示',
    sortOrder: '排序',
    addResult: '添加成果'
  },
  
  // 案例研究
  caseStudy: {
    caseId: '案例 ID',
    title: '案例標題',
    subtitle: '副標題',
    clientName: '客戶名稱',
    industry: '行業',
    coverImage: '封面圖',
    images: '案例圖片',
    challenge: '面臨挑戰',
    solution: '解決方案',
    results: '實施成果',
    resultTags: '成果標籤',
    addImage: '添加圖片',
    addTag: '添加標籤'
  },
  
  // FAQ
  faq: {
    question: '問題',
    answer: '答案',
    sortOrder: '排序',
    addQuestion: '添加問題'
  },
  
  // 核心优势
  advantage: {
    icon: '圖標',
    title: '優勢標題',
    description: '優勢描述',
    sortOrder: '排序'
  },
  
  // 服务流程
  process: {
    stepNumber: '步驟編號',
    title: '步驟標題',
    description: '步驟描述',
    icon: '圖標'
  },
  
  // 网站配置
  siteConfig: {
    siteName: '網站名稱',
    siteTitle: '網站標題',
    keywords: '關鍵詞',
    description: '網站描述',
    copyright: '版權信息',
    icpLicense: 'ICP 備案號',
    publicSecurityLicense: '公安備案號',
    seoConfig: 'SEO 配置',
    basicConfig: '基礎配置',
    contactConfig: '聯系配置',
    socialLinks: '社交鏈接'
  },
  
  // 咨询管理
  inquiry: {
    name: '姓名',
    phone: '電話',
    email: '郵箱',
    company: '公司',
    content: '咨詢內容',
    status: '狀態',
    handleStatus: '處理狀態',
    handled: '已處理',
    unhandled: '未處理',
    contactTime: '聯系時間',
    remark: '備註'
  },
  
  // 提示信息
  message: {
    confirmDelete: '確定要刪除嗎？',
    deleteSuccess: '刪除成功',
    saveSuccess: '保存成功',
    updateSuccess: '更新成功',
    createSuccess: '創建成功',
    operationFailed: '操作失敗',
    dataNotExist: '數據不存在',
    pleaseSelect: '請選擇',
    inputRequired: '請輸入',
    uploadSuccess: '上傳成功',
    uploadFailed: '上傳失敗',
    fileSizeLimit: '文件大小不能超過',
    fileTypeLimit: '只支持圖片格式',
    networkError: '網絡錯誤，請稍後重試'
  },
  
  // 验证规则
  validation: {
    required: '{field}不能為空',
    minLength: '{field}長度不能小於{min}個字符',
    maxLength: '{field}長度不能大於{max}個字符',
    email: '請輸入正確的郵箱地址',
    phone: '請輸入正確的手機號碼',
    url: '請輸入正確的 URL 地址',
    number: '請輸入數字',
    pattern: '格式不正確'
  },
  
  // 语言切换
  language: {
    switcher: '語言',
    zhCN: '簡體中文',
    zhTW: '繁體中文',
    en: 'English',
    ru: 'Русский'
  }
}
